import React from 'react';
import { Paper, Typography, Box, Chip } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import LocationOnIcon from '@mui/icons-material/LocationOn';

function Header() {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        mb: 3,
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        background: 'rgba(255, 255, 255, 0.98)',
        backdropFilter: 'blur(20px)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 6,
          background: 'linear-gradient(90deg, #003c71 0%, #ffc425 50%, #003c71 100%)',
        },
      }}
    >
      <Box sx={{ mb: 3 }}>
        <svg width="200" height="60" viewBox="0 0 200 60" xmlns="http://www.w3.org/2000/svg">
          <rect x="10" y="10" width="40" height="40" fill="#003c71"/>
          <rect x="15" y="15" width="30" height="30" fill="#ffc425"/>
          <text x="60" y="35" fontFamily="Arial, sans-serif" fontSize="24" fontWeight="bold" fill="#003c71">SPU</text>
          <text x="60" y="48" fontFamily="Arial, sans-serif" fontSize="10" fill="#003c71">SRIPATUM UNIVERSITY</text>
        </svg>
      </Box>

      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 700,
          color: 'primary.main',
          mb: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <SchoolIcon sx={{ fontSize: 40, color: 'secondary.main' }} />
        E-Learning Link Converter
      </Typography>

      <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
        แปลงลิงก์
      </Typography>

      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Chip
          icon={<SchoolIcon />}
          label="มหาวิทยาลัยศรีปทุม"
          color="primary"
          variant="outlined"
        />
        <Chip
          icon={<LocationOnIcon />}
          label="วิทยาเขตชลบุรี"
          sx={{
            borderColor: 'secondary.main',
            color: 'secondary.dark',
            '& .MuiChip-icon': {
              color: 'secondary.main',
            },
          }}
          variant="outlined"
        />
      </Box>
    </Paper>
  );
}

export default Header;
